import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		title: {
			textAlign: 'left',

			[theme.breakpoints.down('sm')]: {
				'& *': {
					textAlign: ({ metaData }) =>
						metaData.mobileAlignment?.metaValue ? `${metaData.mobileAlignment.metaValue} !important` : null,
				},
			},
		},

		modal: {
			backgroundColor: 'transparent',
			boxShadow: 'none',
			width: '100%',
			overflowY: 'visible',
		},
	}),
	{ name: 'Video-Video8' },
)

export default useStyles
